package com.example.event_management_system.ui.theme

import androidx.compose.ui.unit.dp

object Dimens {

    // Spacing / Spacer heights & widths
    val spacingXxSmall = 2.dp
    val spacingXSmall  = 4.dp
    val spacingSmall   = 8.dp
    val spacingMedium  = 12.dp
    val spacingLarge   = 16.dp
    val spacingXLarge  = 24.dp
    val spacingXxLarge = 32.dp

    // Padding (same scale, named by usage context)
    val paddingSmall   = 8.dp
    val paddingMedium  = 16.dp
    val paddingLarge   = 24.dp
    val paddingXLarge  = 32.dp

    // Corner radius
    val cornerRadiusSmall = 4.dp

    // Border widths
    val borderWidthDefault  = 1.dp
    val borderWidthSelected = 2.dp

    // Card elevation
    val cardElevationDefault = 1.dp

    // Component sizes
    val loadingIndicatorSize        = 48.dp
    val loadingIndicatorSizeSmall   = 24.dp
    val loadingIndicatorStrokeWidth = 2.dp

    // Screen-level constraints
    val buttonHeightPrimary = 50.dp
    val maxContentWidth     = 400.dp

    // Calendar
    val calendarDaySize     = 24.dp
    val calendarYearDaySize = 20.dp
}
